(function(){
  try {
    var body = document.body;
    if (!body) return;
    var isKap = body.classList.contains('collection-kapalua-golf') || body.classList.contains('collection-kapalua')
      || document.getElementById('mfac-kap') || document.getElementById('mfac-holes') || document.getElementById('mfac-reveal-kapalua');
    if (!isKap) return;
    var wrap = document.getElementById('HeaderWrapper');
    if (!wrap) return;
    var lightIds = {
      'shopify-section-98b984d6-6414-4fd5-be8f-0a50c6d6fd9f': true,
      'shopify-section-course_plantation': true,
      'shopify-section-course_bay': true,
      'shopify-section-kap_soft_exit': true,
      'shopify-section-holes_heading': true,
      'shopify-section-holes_strip': true,
      'shopify-section-main-collection': true
    };
    var darkIds = {
      'shopify-section-advanced_content_6EJJ7L': true,
      'shopify-section-mfac_kapalua_reveal': true
    };
    function sectionAtHeader() {
      var y = (wrap.getBoundingClientRect().bottom || 80) + 8;
      var nodes = document.querySelectorAll('[id^="shopify-section-"]');
      for (var i = 0; i < nodes.length; i++) {
        var r = nodes[i].getBoundingClientRect();
        if (r.bottom > y && r.top < y + 40) return nodes[i].id;
      }
      return '';
    }
    function tick() {
      if (!wrap.classList.contains('header-wrapper--overlay')) {
        wrap.classList.remove('mfac-kap-on-light');
        return;
      }
      var id = sectionAtHeader();
      if (darkIds[id]) { wrap.classList.remove('mfac-kap-on-light'); return; }
      if (lightIds[id] || id) wrap.classList.add('mfac-kap-on-light');
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    tick();
  } catch (e) {}
})();
